import client from './api-client';

export const serviceGetCfgForm = async (query) => {
    try {
        const response = await client.getSelect(`cfg-forms?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}

export const serviceGetImplicados = async(query) => {
    try {
        const response = await client.getSelect(`caso/implicado/terceros?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } catch(error){
        throw error;
    }
}

export const serviceGetGestionImplicado = async(query) => {
    try {
        const response = await client.getSelect(`gestion-implicado?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } catch(error){
        throw error;
    }
}

export const serviceGetDatosImplicado = async(query) => {
    try {
        const response = await client.getSelect(`caso/implicado?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } catch(error){
        throw error;
    }
}

export const serviceGetCompanias = async() => {
    try {
        const response = await client.getSelect(`companias`);
       
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } catch(error){
        throw error;
    }
}

export const serviceGetMonedas = async (query) => {
    try {
        const response = await client.getSelect(`monedas?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } catch (error) {
        throw error;
    }
}

export const serviceRecepcionar = async(body) => {
    try {
        const response = await client.post('caso/cobro-tercero/recepcionar', body);
        return response.data;
    } catch(error) {
        throw error;
    }
}
export const serviceParametroFecha = async(query) => {
    try {
        
        const response = await client.getSelect(`parametros?q=${query}`);
        
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const servicesGetTipoSiniestro = async(query) => {
    try {
        
        const response = await client.getSelect(`detalles?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } catch(error){
        throw error;
    }
}